/** PM Pagination — paginated view mode for message threads. */

// ─── Paginated view ─────────────────────────────────────────────

/**
 * Toggle between chat view and paginated view.
 */
window.togglePagedView = function() {
  // Close the actions menu
  $("#conversation-actions-menu").addClass("hidden");

  if (window.pagedViewActive) {
    window.deactivatePagedView();
  } else {
    window.activatePagedView();
  }
};

/**
 * Switch to paginated view mode.
 */
window.activatePagedView = function() {
  var threadId = window.get_active_thread_id();
  if (!threadId) return;

  window.pagedViewActive = true;
  localStorage.setItem('pm_paged_view', '1');

  // Hide jump-to-latest, show pagination controls
  $("#jump-to-latest-btn").addClass("hidden").removeClass("flex");
  $("#paged-view-controls").removeClass("hidden");

  // Update menu label
  window.updatePagedViewLabel();

  // Load page 1 (newest messages)
  window.loadPagedMessages(1);
};

/**
 * Switch back to chat (infinite scroll) view mode.
 */
window.deactivatePagedView = function() {
  window.pagedViewActive = false;
  localStorage.setItem('pm_paged_view', '0');

  // Hide pagination controls
  $("#paged-view-controls").addClass("hidden");

  // Update menu label
  window.updatePagedViewLabel();

  // Reload thread in chat mode
  var threadId = window.get_active_thread_id();
  if (threadId) {
    window.view_thread(threadId, true);
  }
};

/**
 * Load a specific page of messages.
 * @param {number|string} page - Page number or 'last' for the newest page
 */
window.loadPagedMessages = function(page) {
  var threadId = window.get_active_thread_id();
  if (!threadId) return;

  var data = { thread: threadId, page: page };

  window.pm_ajax_request_active = 1;
  $.ajax({
    type: "POST",
    url: "/app/messages/load-paged",
    data: data,
    dataType: "json"
  }).done(function(data) {
    if (data.error) {
      return;
    }
    if (data.body) {
      var c = $("#threads_right");
      var newWrapper = $('<div id="messages_wrapper"></div>');
      newWrapper.append(data.body);
      var oldWrapper = c.find('#messages_wrapper');
      if (oldWrapper.length) {
        oldWrapper.replaceWith(newWrapper);
      } else {
        c.empty().append(newWrapper);
      }

      window.pagedViewCurrentPage = data.page;
      window.pagedViewTotalPages = data.total_pages;
      window.renderPaginationControls(data.page, data.total_pages);

      if (data.contact_status) window.update_header_status(data.contact_status);
      if (data.contact_active === false) {
        $("#threads_right_bottom").addClass("hidden");
        if (data.contact_name) {
          $("#current_thread_username").text(data.contact_name);
        }
      }

      // Initialize icons and audio players in new content
      if (window.LucideIcons) window.LucideIcons.initialize(newWrapper.get(0));
      if (window.initAudioPlayers) window.initAudioPlayers();
    }
  }).always(function() {
    window.pm_ajax_request_active = 0;
  });
};

/**
 * Render pagination controls (page numbers with prev/next).
 * @param {number} current - Current page number
 * @param {number} total - Total number of pages
 */
window.renderPaginationControls = function(current, total) {
  var nav = document.getElementById('pagination-nav');
  if (!nav) return;

  var html = '';
  var btnBase = 'inline-flex items-center justify-center h-8 min-w-8 px-2 rounded-full text-sm transition-colors duration-150 border-0 cursor-pointer ';
  var btnNormal = btnBase + 'text-gray-600 hover:bg-sky-100 hover:text-sky-600 bg-transparent';
  var btnActive = btnBase + 'bg-sky-500 text-white shadow-sm';
  var btnDisabled = btnBase + 'text-gray-300 cursor-default bg-transparent';

  // On mobile, show compact view: < N / M >
  var isMobile = window.innerWidth < 640;

  if (isMobile) {
    html += '<button class="' + (current > 1 ? btnNormal : btnDisabled) + '"'
      + (current > 1 ? ' onclick="window.loadPagedMessages(' + (current - 1) + ')"' : '')
      + ' aria-label="' + (window.t ? window.t('legacy.pm.previous_page') : 'Previous page') + '">'
      + '<i data-lucide="chevron-left" class="w-4 h-4"></i></button>';
    html += '<span class="text-xs text-gray-500 px-1.5">' + window.formatCompactPaginationNumber(current) + ' / ' + window.formatCompactPaginationNumber(total) + '</span>';
    html += '<button class="' + (current < total ? btnNormal : btnDisabled) + '"'
      + (current < total ? ' onclick="window.loadPagedMessages(' + (current + 1) + ')"' : '')
      + ' aria-label="' + (window.t ? window.t('legacy.pm.next_page') : 'Next page') + '">'
      + '<i data-lucide="chevron-right" class="w-4 h-4"></i></button>';
  } else {
    // Previous button
    html += '<button class="' + (current > 1 ? btnNormal : btnDisabled) + '"'
      + (current > 1 ? ' onclick="window.loadPagedMessages(' + (current - 1) + ')"' : '')
      + ' aria-label="' + (window.t ? window.t('legacy.pm.previous_page') : 'Previous page') + '">'
      + '<i data-lucide="chevron-left" class="w-4 h-4"></i></button>';

    // Page numbers with ellipsis
    var pages = window.getPaginationPages(current, total);
    for (var i = 0; i < pages.length; i++) {
      var p = pages[i];
      if (p === '...') {
        html += '<span class="text-gray-400 px-0.5 text-xs">...</span>';
      } else if (p === current) {
        html += '<button class="' + btnActive + '">' + window.formatCompactPaginationNumber(p) + '</button>';
      } else {
        html += '<button class="' + btnNormal + '" onclick="window.loadPagedMessages(' + p + ')">' + window.formatCompactPaginationNumber(p) + '</button>';
      }
    }

    // Next button
    html += '<button class="' + (current < total ? btnNormal : btnDisabled) + '"'
      + (current < total ? ' onclick="window.loadPagedMessages(' + (current + 1) + ')"' : '')
      + ' aria-label="' + (window.t ? window.t('legacy.pm.next_page') : 'Next page') + '">'
      + '<i data-lucide="chevron-right" class="w-4 h-4"></i></button>';
  }

  nav.innerHTML = html;
  if (window.LucideIcons) window.LucideIcons.initialize(nav);
};

window.formatCompactPaginationNumber = function(value) {
  var number = Number(value) || 0;
  if (number >= 1000000) {
    return (Math.floor(number / 100000) / 10).toFixed(1).replace(/\.0$/, '') + 'm';
  }
  if (number >= 10000) {
    return Math.floor(number / 1000) + 'k';
  }
  if (number >= 1000) {
    return (Math.floor(number / 100) / 10).toFixed(1).replace(/\.0$/, '') + 'k';
  }

  return String(number);
};

/**
 * Generate array of page numbers to display, with ellipsis for gaps.
 * Always shows first, last, and 2 pages around current.
 * @param {number} current
 * @param {number} total
 * @returns {Array<number|string>}
 */
window.getPaginationPages = function(current, total) {
  if (total <= 7) {
    var arr = [];
    for (var i = 1; i <= total; i++) arr.push(i);
    return arr;
  }

  var pages = [];
  var rangeStart = Math.max(2, current - 2);
  var rangeEnd = Math.min(total - 1, current + 2);

  pages.push(1);
  if (rangeStart > 2) pages.push('...');
  for (var j = rangeStart; j <= rangeEnd; j++) pages.push(j);
  if (rangeEnd < total - 1) pages.push('...');
  pages.push(total);

  return pages;
};

/**
 * Update the paginated/chat view toggle label and icon.
 */
window.updatePagedViewLabel = function() {
  var label = document.getElementById('toggle-paged-view-label');
  var btn = document.getElementById('toggle-paged-view-btn');
  if (!label || !btn) return;

  var icon = btn.querySelector('[data-lucide]');
  if (window.pagedViewActive) {
    label.textContent = window.t ? window.t('legacy.pm.chat_view') : 'Scroll view';
    if (icon) icon.setAttribute('data-lucide', 'message-circle');
  } else {
    label.textContent = window.t ? window.t('legacy.pm.paginated_view') : 'Paginated view';
    if (icon) icon.setAttribute('data-lucide', 'book-open');
  }
  if (window.LucideIcons) window.LucideIcons.initialize(btn);
};
